import { Component, EventEmitter, Input, Output, forwardRef, inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { debounceTime, Subject } from 'rxjs';
import { ContatoService } from '../../../service/contato.service';
import { Contato } from '../../../model/contato/contato.model';
import { IdNome } from '../../../model/id-nome.model';
import { CelularMaskPipe } from '../../../pipe/celular-mask.pipe';
import { MethodsUtils } from '../../../util/methods.utils';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-campo-busca-contato',
  standalone: true,
  imports: [MatTooltip, CelularMaskPipe, MatIconModule],
  templateUrl: './campo-busca-contato.component.html',
  styleUrl: './campo-busca-contato.component.css',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CampoBuscaContatoComponent), multi: true }
  ]
})
export class CampoBuscaContatoComponent implements ControlValueAccessor {

  @Input() label = 'Contato';
  @Input() permitirRemover = true;
  @Output() contatoAlterado = new EventEmitter<Contato | null>();

  @Input() set contato(value: Contato | null) {
    this.contatoSelecionado = value ?? null;
  }

  contatoSelecionado: Contato | null = null;
  texto = '';
  sugestoes: Contato[] = [];
  buscando = false;
  tocado = false;
  disabled = false;

  private readonly contatoService = inject(ContatoService);
  private readonly buscaSubject = new Subject<string>();
  private onChange: (value: Contato | null) => void = () => { /**/ };
  private onTouched: () => void = () => { /**/ };

  constructor() {
    this.buscaSubject.pipe(debounceTime(300)).subscribe(texto => this.buscar(texto));
  }

  writeValue(value: Contato | null): void {
    this.contatoSelecionado = value ?? null;
  }

  registerOnChange(fn: (value: Contato | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  pesquisar(texto: string) {
    this.tocado = true;
    this.texto = texto;
    this.buscaSubject.next(texto);
  }

  private buscar(texto: string) {
    if (!texto || texto.trim().length < 2) {
      this.sugestoes = [];
      this.buscando = false;
      return;
    }
    this.buscando = true;
    const filtro: IdNome = { nome: texto };
    this.contatoService.buscarContatos(true, filtro, 0, 5).subscribe({
      next: res => {
        this.sugestoes = res ?? [];
        this.buscando = false;
      },
      error: () => this.buscando = false
    });
  }

  selecionar(contato: Contato) {
    this.contatoSelecionado = contato;
    this.sugestoes = [];
    this.texto = '';
    this.onChange(contato);
    this.contatoAlterado.emit(contato);
    this.onTouched();
  }

  remover() {
    this.contatoSelecionado = null;
    this.onChange(null);
    this.contatoAlterado.emit(null);
  }

  iconeStatus(contato: Contato): string {
    return MethodsUtils.informacoesPorStatusContato(contato.statusContato, true)
      || './assets/icones/icons-contato/gray-min.svg';
  }

  tooltipStatus(contato: Contato): string {
    return MethodsUtils.informacoesPorStatusContato(contato.statusContato, false);
  }
}
